/*************************************************************************
 *
 * COMPRO CONFIDENTIAL
 * __________________
 *
 *  [2015] - [2020] Compro Technologies Private Limited
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Compro Technologies Private Limited. The
 * intellectual and technical concepts contained herein are
 * proprietary to Compro Technologies Private Limited and may
 * be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Compro Technologies Pvt. Ltd..
 ***************************************************************************/

/***********************************************************
 * comproDLS SDK drive Adaptor
 * Functions for calling Drive-service API.
 ************************************************************/

/*********************************
 * Setting Up Module Entry Point
 **********************************/

var q = require('q');
var request = require('superagent');
var Agent = require('agentkeepalive');

var helpers = require('../../helpers');
var DLSError = helpers.errors.DLSError;

module.exports = documents;

var keepaliveAgent = new Agent({
  timeout: 60000,
  freeSocketTimeout: 30000
});

/*********************************
 * Public Function definitions
 **********************************/
function documents() {
  return {
    getAParticularDocument: getAParticularDocument.bind(this),
    getAllDocumentsInAFolder: getAllDocumentsInAFolder.bind(this),
    createMultipleDocuments: createMultipleDocuments.bind(this),
    updateMultipleDocuments: updateMultipleDocuments.bind(this),
    deleteMultipleDocuments: deleteMultipleDocuments.bind(this),
  };
}

/*
  options = {
    accountid : 'string', //mandatory
    extuserid : 'string', //mandatory
    documentid : 'string', //mandatory
    folderid: 'string',  //mandatory
  }
*/
function getAParticularDocument(options) {
  var self = this;
  var dfd = q.defer();

  if (options && options.accountid && options.extuserid && options.documentid && options.folderid) {
    //Passed all validations, Construct API url
    var url = self.config.DEFAULT_HOSTS.DRIVE + self.config.DRIVE_API_URLS.getAParticularDocument;
    var urlOptions = {
      accountid: options.accountid, extuserid: options.extuserid,
      documentid: options.documentid
    };
    url = helpers.api.constructAPIUrl(url, urlOptions);

    var params = { folderid: options.folderid };
    //Setup request with URL and Params
    var requestAPI = request.get(url).query(params);

    if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI.end(function (err, response) {
      if (err) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
        dfd.reject(err);
      }
      else { dfd.resolve(response.body); }
    });
  }
  else {
    var error = {};
    error.message = error.description = 'Mandatory params - accountid or extuserid or ' +
      'documentid or folderid not found in request options.';
    error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
    dfd.reject(error);
  }
  return dfd.promise;
}

/*
  options = {
    accountid: 'string', //mandatory
    extuserid: 'string', //mandatory
    folderid: 'string',  //mandatory
    classid: 'string',
    productcode: 'string',
    assigned_path_id: 'string',
    item-code: 'string',
    cursor: 'string'
  }
*/
function getAllDocumentsInAFolder(options) {
  var self = this;
  var dfd = q.defer();

  if (options && options.accountid && options.extuserid && options.folderid) {
    //Passed all validations, Construct API url
    var url = self.config.DEFAULT_HOSTS.DRIVE + self.config.DRIVE_API_URLS.getAllDocumentsInAFolder;
    url = helpers.api.constructAPIUrl(url,
      { accountid: options.accountid, extuserid: options.extuserid });

    // Contruct parameters
    var params = { folderid: options.folderid };
    if (options.classid) { params.classid = options.classid; }
    if (options.productcode) { params.productcode = options.productcode; }
    if (options.assigned_path_id) { params.assigned_path_id = options.assigned_path_id; }
    if (options['item-code']) { params['item-code'] = options['item-code']; }
    if (options.cursor) { params.cursor = options.cursor; }

    //Setup request with URL and Params
    var requestAPI = request.get(url).query(params);

    if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI.end(function (err, response) {
      if (err) {
        err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
        dfd.reject(err);
      }
      else { dfd.resolve(response.body); }
    });
  }
  else {
    var error = {};
    error.message = error.description = 'Mandatory params - accountid or extuserid or folderid ' +
      'not found in request options.';
    error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
    dfd.reject(error);
  }
  return dfd.promise;
}

/*
  options = {
    accountid: 'string',          // mandatory
    extuserid: 'string',          // mandatory
    body: {                       // mandatory
      orgid: 'string',            // mandatory
      classid: 'string',
      productcode: 'string',      // mandatory
      dls_user_id: 'string',      // mandatory
      collaborator_id: 'string'   // optional; mandatory if some OTHER user is updating this document.
      entities: [                 // mandatory (Min length 1)
        {
          item_code: 'string',
          folderid: 'string',     // mandatory
          documentid: 'string',   // mandatory
          tag: 'string',
          timestamp: <epoch>,     // mandatory
          ttl: <number>,          // optional, default - 3 months
          data: {}                // mandatory, state JSON
        },
        ...
      ]
    }
  }
*/
function createMultipleDocuments(options) {
  var self = this;
  var dfd = q.defer();

  if (options && options.accountid && options.extuserid && options.body) {
    // Passed all validations, Contruct API url

    var url = self.config.DEFAULT_HOSTS.DRIVE + self.config.DRIVE_API_URLS.documents;
    url = helpers.api.constructAPIUrl(url, {
      accountid: options.accountid, userid: options.extuserid
    });

    // Setup request with URL and Params
    var requestAPI = request.post(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.body);

    if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI
      .agent(keepaliveAgent)
      .end(function(error, response) {
        if (error) {
          var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
    });
  } else {
    var err = {};
    err.message = err.description = 'Mandatory param - accountid, extuserid or body' +
      ' not found in request options.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
  return dfd.promise;
}

/*
  options = {
    accountid: 'string',          // mandatory
    extuserid: 'string',          // mandatory
    body: {                       // mandatory
      collaborator_id: 'string'   // optional; mandatory if some OTHER user is updating this document.
      entities: [                 // mandatory (Min length 1)
        {
          folderid: 'string',     // mandatory
          documentid: 'string',   // mandatory
          timestamp: <epoch>,     // mandatory
          ttl: <number>,
          data: {}
        },
        ...
      ]
    }
  }
*/
function updateMultipleDocuments(options) {
  // Initializing promise
  var deferred = q.defer();
  var self = this;
  var error = {};

  if (options && options.accountid && options.extuserid && options.body) {
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.DRIVE + self.config.DRIVE_API_URLS.documents;

    url = helpers.api.constructAPIUrl(url, {
      accountid: options.accountid, userid: options.extuserid
    });

    // Setup request with URL and Params
    var requestAPI = request.put(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.body);

    if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI
      .agent(keepaliveAgent)
      .end(function(error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          deferred.reject(error);
        } else {
          deferred.resolve(response.body);
        }
      });
  } else {
    error.message = error.description = 'Mandatory param - accountid, extuserid or body' +
      ' not found in the request options.';
    error = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, error);
    deferred.reject(error);
  }

  return deferred.promise;
}

/*
  options = {
    accountid: 'string',        // mandatory
    extuserid: 'string',        // mandatory
    body: {                     // mandatory
      entities: [               // mandatory (Min length 1)
        {
          folderid: 'string',   // mandatory
          documentid: 'string', // mandatory
        },
        ...
      ]
    }
  }
*/
function deleteMultipleDocuments(options) {
  var self = this;
  var dfd = q.defer();

  if (options && options.accountid && options.extuserid && options.body) {
    // Passed all validations, Contruct API url
    var url = self.config.DEFAULT_HOSTS.DRIVE + self.config.DRIVE_API_URLS.documents;
    url = helpers.api.constructAPIUrl(url, {
      accountid: options.accountid, userid: options.extuserid
    });

    // Setup request with URL and Params
    var requestAPI = request.delete(url)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .send(options.body);

    if (self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI
      .agent(keepaliveAgent)
      .end(function (error, response) {
        if (error) {
          var err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(err);
        }
        else { dfd.resolve(response.body); }
    });
  }
  else {
    var err = {};
    err.message = err.description = 'Mandatory param - accountid, extuserid or body' +
      ' not found in request options.';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }

  return dfd.promise;
}
